export default "__VITE_ASSET__5338ff17__"